<template>
  <a-modal title="西药中成药详情" :width="980" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    v-if="hackReset" @cancel="handleCancel">
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="cancel" @click="handleRefuse" v-show="this.kg">
        审核驳回
      </a-button>
      <a-button key="submit" type="primary" @click="handleSubmit" v-show="this.kg" :loading="approved">
        审核通过
      </a-button>
    </template>
    <div class="viewDetial-tiem">
      <a-row style="height:30px">
        <a-col :span="8">
          <label>姓名：{{ this.loadUser.patientName + '  ' + (this.loadUser.patientSex == 1 ? '男' : this.loadUser.patientSex == 2 ? '女' : '') + '   ' + (this.loadUser.patientAge +'岁')   }}</label>
        </a-col>
        <a-col :span="8">
          <label>就诊科室：{{this.loadUser.deptName}}</label>
        </a-col>
        <a-col :span="8">
          <label>状态：<span style="color:#1890FF">{{ this.loadUser.status == '1' ? '审核撤销' : this.loadUser.status == '2' ? '审核驳回' : this.loadUser.status == '3' ? '审核通过' :
    this.loadUser.status == '4' ?
          '审核中' : this.loadUser.status == '5' ? '审核超时' : '' }}</span></label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col :span="8">
          <label>诊断：<span style="padding-right:10px" v-for="(item,key) in this.loadUser.diaName" :key="key">{{ item + '&nbsp;&nbsp;' }} </span></label>
        </a-col>
        <a-col :span="8">
          <label>就诊医师：{{this.loadUser.drRealName}}</label>
        </a-col>
        <a-col :span="8">
          <label>费用：<span style="color:red"> {{ this.loadUser.totalPrice }}</span></label>
        </a-col>
      </a-row>

      <div style="border-bottom: 1px dotted #ccc;margin: 10px 0 ;">

      </div>


      <a-row style="height:30px">
        <a-col :span="8">
          <label>开方日期：{{ this.loadUser.createTime}}</label>
        </a-col>
        <a-col :span="8">
          <label>药房：{{ this.loadUser.pharmacyName }}</label>
        </a-col>
      </a-row>

      <a-row style="height:30px;margin-bottom:10px">
        <a-col :span="8">
          <label>处方编号：{{ this.loadUser.recipeNo }}</label>
        </a-col>
        <a-col :span="8">
          <label>外配药房：{{ this.loadUser.negotiationFlag == 0 ? '内配' : this.loadUser.negotiationFlag == 1 ? '外配' : '' }} </label>
          </a-col>
      </a-row>

    </div>




    <div>
      <div class="viewDetial-title">药品信息</div>
      <div>
        <s-table ref="table" :columns="columns" :data="loadData" :rowKey="(record) => record.mediId">


          <a slot="freqName" slot-scope="text, record">{{ (record.wmOnceDosage == undefined ? '' : record.wmOnceDosage) + '' + (record.mediUnit == undefined ? '' : record.mediUnit  ) + '/次，' + (record.freqName == undefined?'' : record.freqName ) }}</a>

        </s-table>
        <div class="totalPrice">
          <a-row style="height:30px;line-height:30px;font-weight: bold;">
            <a-col :span="16" style="padding-left:5px">
              <label>总计：</label>
            </a-col>
            <a-col :span="4" style="padding-left:20px">
              <label>{{this.loadUser.totalCount}}</label>
            </a-col>
            <a-col :span="3" style="padding-left:14px">
              <label>{{this.loadUser.totalPrice}}</label>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <!-- 审核驳回窗口 -->
    <a-modal v-model="refuse" title="审核驳回" @cancel="handleBack">
      <template slot="footer">
        <a-button key="back" @click="handleBack">
          取消
        </a-button>
        <a-button key="cancel" @click="handleReject" :loading="failedApproved">
          审核驳回
        </a-button>
      </template>
      <a-textarea v-model="refuseReason" placeholder="请输入驳回理由" :auto-size="{ minRows: 3, maxRows: 5 }" />
    </a-modal>
    <a-modal :visible="previewVisible" width="900px" height="450px" style="overflow:hidden" :closable="false"
      :footer="null" @cancel="handleCancelImage">
      <img alt="example" style="width: 300px;transform: rotate(0deg) translateY(0px) translateX(280px);"
        :src="previewImage" />
    </a-modal>
    <a-modal :visible="isifram" width="900px" height="500px" style="overflow:hidden" :closable="true"
      @cancel="handleIframBack">
      <!-- <template slot='footer'>
          <a-button key="back" @click="handleIframBack">
            取消
          </a-button>
      </template> -->
      <iframe style="width:100%;height:500px" :src="iframeSrc" frameborder="0"></iframe>
    </a-modal>
  </a-modal>
</template>

<script>
  import { STable } from '@/components';
  import moment from 'moment'
  import { recipeDetial , recipeAdopt , recipeCancel } from '@/api/modular/interhospital/recipe/recipeManage'
  export default {
    components:{
      STable
    },
    data () {
      return {
        iframeSrc: '',
        isifram : false,
        queryParam : {},
        visible: false,
        hackReset : true,
        kg : '',
        // 审核通过按钮防多次点击
        approved : false,
        // 审核不通过
        failedApproved : false,
        // 查看签名缩略图
        previewVisible : false,
        previewImage : '',

        refuse : false,
        refuseReason : '',

        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        verifytimeDateString: '',
        
        confirmLoading: false,
        form: this.$form.createForm(this),
        loadUser : [],
        loadData:  parameter => {
          return  new Promise(async(resolve,reject)=>{
              const res = await recipeDetial(Object.assign(parameter, this.queryParam));
              this.loadUser = res.data;
            resolve(res.data.mediDetailVOList);
          });
        },
        columns : [
          
            {
              title: '药品编码',
              align: 'center',
              dataIndex: 'mediCode',
            },
            {
              title: '药品名称',
              align: 'left',
              dataIndex: 'mediName',

            },
            {
              title: '规格',
              align: 'left',
              dataIndex: 'specification',
            },
            {
              title: '用药途径',
              align: 'left',
              dataIndex: 'useType',
            },
            {
              title: '剂量，频次',
              align: 'left',
              dataIndex: 'freqName',
              scopedSlots: { customRender: 'freqName' },
            },
            {
              title: '数量',
              align: 'center',
              dataIndex: 'mediNum'
            },
            {
              title: '单位',
              align: 'center',
              dataIndex: 'baseUnit'
            },
            {
              title: '单价',
              align: 'center',
              dataIndex: 'unitPrice'
            },
            {
              title: '金额',
              align: 'right',
              dataIndex: 'kindTotalPrice'
            },
            {
              title: '用药天数',
              align: 'center',
              dataIndex: 'dayNum'
            },
            {
              title: '备注',
              align: 'center',
              dataIndex: 'remarks',
              
            },
        ],
        // 是否外配处方
        isPharmacyName : "",
      }
    },
    created(){
      this.loadUser = [];
    },
    methods: {
      moment,
      // 初始化方法
      add (record,kg) {
        this.kg = !kg;
        this.queryParam.id = record.id;
        this.visible = true;

        if (record.pharmacyName == 2) { //外配
          this.isPharmacyName = true;
        } else { //内配
          this.isPharmacyName = false;
        }
      },
      
      /**
       * 审核通过
       */
      handleSubmit () {
        this.approved = true;
        recipeAdopt({ recipeId: this.loadUser.id }).then(res => {
          this.approved = false;
          if (res.code == '200') {

            if (this.isPharmacyName) {
              this.$message.success('审核成功,已自动签名,请及时核验并上传');
            } else {
              this.$message.success('审核成功,已自动签名');
            }
            this.visible = false;
            this.hackReset = false;
            this.$nextTick(()=>{
              this.hackReset = true;
            })
            this.$parent.handleOk();
          } else {
            if (res.code == 201) {
              this.$message.info(res.msg)
              let iframeSrc = 'https://interhospital.youjiankang.net/' + res.data.split('//')[2]
              this.iframeSrc = iframeSrc;
              this.isifram = true;
              this.visible = false;
            } else {
              this.$message.error(res.msg)
            }
            
          }
          
        })
        // 
      },
       // 审核驳回
      handleReject(){
        let parameter = {};
        parameter.recipeId = this.loadUser.id;
        parameter.refuseReason = this.refuseReason;
        if(parameter.refuseReason == ''){
          this.$message.warning('请输入驳回理由，驳回理由不能为空！');
        }else{
          this.failedApproved = true;
          // parameter
          recipeCancel(parameter).then(res=>{
            this.failedApproved = false;
            console.log(res)
            if(res.code == '200'){
              this.$message.success('操作成功');
              this.refuse = false;
              this.visible = false;
              this.hackReset = false;
              this.$nextTick(()=>{
                this.hackReset = true;
              })
              this.$parent.handleOk();
            } else {
              this.$message.info(res.msg)
            }
          })
        }
        
      },
     
      // 点击调用审核驳回按钮调用 输入驳回理由窗口
      handleRefuse(){
        this.visible = false;
        this.refuse = true;

      },
     
      // 驳回输入框点击取消按钮
      handleBack(){
        this.refuse = false;
        this.visible = true;
        this.rejectValue = '';
      },
      //点击取消按钮
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },
      // 点击查看大图
      seeIamge(type){
        if(type == 'ysSign'){
          this.previewImage = 'data:image/png;base64,' + this.loadUser.ysSign
        }else if(type == 'drSign'){
          this.previewImage = 'data:image/png;base64,' + this.loadUser.drSign
        }
        this.visible = false;
        this.previewVisible = true;
      },
      // 关闭缩略图
      handleCancelImage(){
        this.previewVisible = false;
        this.visible = true;
      },
      handleIframBack() {
        this.isifram = false;
        this.$parent.handleOk();
      }
    },
  }
</script>
<style lang="less" scoped>
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
}
/deep/.s-table-tool{
  display: none;
}
.totalPrice{
  line-height: 30px;
  padding: 0 30px;
}
.detialImage{
  width: 80px;
  height: 30px;
  margin: 0 10px;
  cursor: pointer;
  
  // transform: rotate();
}
</style>
